import React from "react";

interface ProgressCirclerightProps {
  achieved: number;
  target: number;
  colour: string;
  heading: string;
  unit: string;
  icon: string;
}

const ProgressCircleright: React.FC<ProgressCirclerightProps> = ({
  achieved,
  target,
  colour,
  heading,
  unit,
  icon,
}) => {
  const r = 30; // Circle radius
  const circ = 2 * Math.PI * r; // Circle circumference
  const progress = Math.min((achieved / target) * 100, 100);
  const strokePct = ((100 - progress) * circ) / 100;

  return (
    <div className="progress-circle-small-container">
      <div className="progress-circle-header">
        {icon && <img src={icon} alt="icon" className="progress-circle-icon" />}
        <span className="progress-circle-icon-placeholder"></span>
        <span
          className="progress-circle-title"
          style={{ color: "var(--text-color)" }}
        >
          {heading}
        </span>
      </div>
      <svg width={160} height={100}>
        <g transform={`rotate(-90 ${"80 50"})`}>
          {/* Background Circle */}
          <circle
            r={r}
            cx={80}
            cy={50}
            fill="transparent"
            stroke="#E8E8E8"
            strokeWidth={"0.6rem"}
          />
          {/* Progress Circle */}
          <circle
            r={r}
            cx={80}
            cy={50}
            fill="transparent"
            stroke={colour}
            strokeWidth={"0.6rem"}
            strokeDasharray={circ}
            strokeDashoffset={strokePct}
            strokeLinecap="round"
          />
        </g>

        {/* Achieved Number - Moved up to 38% to clear space for wrapping text */}
        <text
          x="50%"
          y="38%"
          dominantBaseline="central"
          textAnchor="middle"
          fontSize="1em"
          fontWeight="bold"
          fill="var(--text-color)"
        >
          {achieved}
        </text>

        {/* Unit Text - Wrapped using foreignObject */}
        {/* x = Center(80) - Width(60)/2 = 50 */}
        <foreignObject x={50} y={48} width={60} height={40}>
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start", // Start text from top of this box
              textAlign: "center",
              fontSize: "0.55em", // Keep font small
              lineHeight: "1.1",
              color: "var(--text-color)",
              wordWrap: "break-word",
              overflowWrap: "anywhere", // Forces long words like 'kilocalories' to break
            }}
          >
            {unit}
          </div>
        </foreignObject>
      </svg>
    </div>
  );
};

export default ProgressCircleright;